var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTache2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.69 69.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.01,48.32c-10.23.85-18.66,9.19-21.65,6.33,12.18-7.23,8.45-9.87,21.54-18.81,14.73-1.73,9.07-17.09,23.25-10.99l7.51-5.64c1.14,2.05,4,5.89,5.69,5.07l10.14-4.94c-2,4.19-4.78,5.61-8.53,8.01-8.94,5.73-10.36-5.27-17,2.68s-7.39-5.8-20.97,18.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.36,68.48c-2.32,2.93-7.43-3.09-11.36-1.27,3.92-8.55,8.89-.97,13.84-7.04,4.57-5.62,11.93-9.74,19.07-5.63-1.21,1.98-6.46,1.61-8.21,2.84l-10.2,7.15-3.14,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24,11.46l5.04-8.56c.61-.67,3.57.4,4.41-.17l4-2.72-12.04,19.89c-.83-.22-2.9-2.46-3.02-3.63s.79-3.41,1.61-4.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTache2);
export default __webpack_public_path__ + "static/media/tache2.52bea362f594d566d217af6ca66a5612.svg";
export { ForwardRef as ReactComponent };